import { useSelector } from 'react-redux';
import * as globalSelectors from 'store/global/selectors';
import * as profileSelectors from 'store/profile/selectors';

const usePreviouslyAcceptedLatestTerms = () => {
  const tempTermsAndConditions = useSelector(globalSelectors.tempTermsAndConditionsSelector);
  const termsAndConditions = useSelector(globalSelectors.termsAndConditionsSelector);
  const consumer = useSelector(profileSelectors.profileConsumerSelector);

  const previouslyAccepted = !!tempTermsAndConditions?.TRIAGE_DISCLAIMER;
  const externalTermsAcceptance = consumer?.externalTermsAcceptance || [];
  const previousUserTermsAndConditions = externalTermsAcceptance.find(terms => {
    return terms.type === 'TRIAGE_DISCLAIMER';
  });
  const latestTermsAndConditionsVersion =
    termsAndConditions?.triage.version || 'Version Not Accepted';

  const previouslyAccpetedTheLatestTerms =
    previouslyAccepted ||
    (previousUserTermsAndConditions &&
      previousUserTermsAndConditions.version === latestTermsAndConditionsVersion);

  return previouslyAccpetedTheLatestTerms;
};

export default usePreviouslyAcceptedLatestTerms;
